import { useFlag } from "@mindlercare/unleash-client";
import { useSelectedPsychologistIdParam } from "../../../hooks/useSelectedPsychologistParam";
import { usePsychologistUser } from "hooks";

export const useWeekTemplates = () => {
  const isWeekScheduleIsEnabled = useFlag("WEEK_SCHEDULE_TEMPLATES");
  const [selectedPsychologistId] = useSelectedPsychologistIdParam();
  const { psychologist } = usePsychologistUser();
  if (!psychologist?.psychologistId) return false;
  return (
    isWeekScheduleIsEnabled &&
    selectedPsychologistId === psychologist.psychologistId
  );
};
